import React from "react";

import CellphoneHorizontalSvg from "../../assets/images/icons/cellphone-horizontal.svg";

export const CellphoneHorizontalIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={CellphoneHorizontalSvg}
        alt={alt || "Cellphone Horizontal"}
    />
);
